export default "__VITE_ASSET__a08fd37e__"